// components
import MainCarousel from "../../components/home/mainCarousel";
import Categories from "./../../components/common/Categories";
import Services from "../../components/home/services";
import Laptops from "../../components/common/Laptops";
import HomeProductDetails from "../../components/common/homeProductDetails";
import RecentlyViewedProducts from "../../components/common/recentlyViewedProducts";
import Phones from "../../components/common/Phones";
import Accessories from "../../components/common/Acccessories";

const Home = () => {
  // Structured data for search engines
  const businessStructuredData = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    name: "Nakuru Security & IT Solutions",
    image: "/logo.png",
    url: "https://www.yourdomain.com",
    telephone: "+254-XXX-XXXXXX",
    address: {
      "@type": "PostalAddress",
      streetAddress: "Near Central Mosque",
      addressLocality: "Nakuru",
      addressRegion: "Rift Valley",
      postalCode: "20100",
      addressCountry: "KE",
    },
    geo: {
      "@type": "GeoCoordinates",
      latitude: "-0.303099",
      longitude: "36.080026",
    },
    openingHoursSpecification: {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ],
      opens: "08:00",
      closes: "17:30",
    },
    sameAs: [
      "https://www.facebook.com/yourpage",
      "https://twitter.com/yourprofile",
    ],
  };

  return (
    <div id="home" role="main" aria-label="Main content">
      {/* Structured data for search engines */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(businessStructuredData),
        }}
      />

      <section aria-labelledby="main-carousel-heading">
        <h1 id="main-carousel-heading" className="sr-only">
          Leading CCTV & Security Solutions in Nakuru, Kenya
        </h1>
        <MainCarousel />
      </section>

      <section
        aria-labelledby="categories-heading"
        itemScope
        itemType="https://schema.org/ItemList"
      >
        <h2 id="categories-heading" className="sr-only">
          Product Categories
        </h2>
        <Categories />
      </section>

      <section
        aria-labelledby="cctvs-heading"
        itemScope
        itemType="https://schema.org/Product"
      >
        <h2 id="cctvs-heading" className="sr-only">
          CCTVs for Sale in Nakuru
        </h2>
        <Laptops />
      </section>

      <section
        aria-labelledby="routers-heading"
        itemScope
        itemType="https://schema.org/Product"
      >
        <h2 id="routers-heading" className="sr-only">
          Wifi Routers and Office Systems
        </h2>
        <Phones />
      </section>

      <section
        aria-labelledby="accessories-heading"
        itemScope
        itemType="https://schema.org/Product"
      >
        <h2 id="accessories-heading" className="sr-only">
          Security System Accessories
        </h2>
        <Accessories />
      </section>

      <section
        aria-labelledby="featured-product-heading"
        itemScope
        itemType="https://schema.org/Product"
      >
        <h2 id="featured-product-heading" className="sr-only">
          Featured Security Products
        </h2>
        <HomeProductDetails />
      </section>

      <section aria-labelledby="recent-products-heading">
        <h2 id="recent-products-heading" className="sr-only">
          Recently Viewed Security Equipment
        </h2>
        <RecentlyViewedProducts />
      </section>

      <section
        aria-labelledby="services-heading"
        itemScope
        itemType="https://schema.org/Service"
      >
        <h2 id="services-heading" className="sr-only">
          Professional Security Services in Nakuru
        </h2>
        <Services />
      </section>
    </div>
  );
};

export default Home;
